
import React from "react";
const ContractsIcon = (props) => {
  return (
    <img src="/images/nuevo_ico_contratos.png" alt=""/>
  );
}
export default ContractsIcon;
